module.exports = __webpack_public_path__ + "img/junior.60585a95.svg";